export interface Latest {
  claim: () => () => boolean
  observe: () => () => boolean
  invalidate: () => void
}

export function createLatest(): Latest {
  let token = 0

  const at = (mine: number) => () => mine === token

  return {
    claim: () => at(++token),
    observe: () => at(token),
    invalidate: () => {
      token += 1
    },
  }
}
